/* ============================================================
   BRICKIES — Set-Vergleich
   Liest den Katalog aus dem eingebetteten JSON der Section und
   stellt bis zu drei Sets gegenueber. Die Auswahl kommt aus der
   URL (?sets=a,b,c) oder aus der Session.
   ============================================================ */
(function () {
  'use strict';

  var root = document.getElementById('bk-compare');
  if (!root) return;

  var dataEl = document.getElementById('bk-compare-data');
  if (!dataEl) return;

  var CATALOG;
  try { CATALOG = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var byHandle = {};
  CATALOG.forEach(function (p) { byHandle[p.handle] = p; });

  var CFG = window.BRICKIES_CONFIG || {};
  var money = new Intl.NumberFormat(CFG.locale || 'de-DE', {
    style: 'currency', currency: CFG.currency || 'EUR'
  });

  function selection() {
    var q = new URLSearchParams(location.search).get('sets');
    var handles = q ? q.split(',') : [];
    if (!handles.length) {
      try {
        handles = (JSON.parse(sessionStorage.getItem('brickies:compare') || '[]') || [])
          .map(function (o) { return o.handle; });
      } catch (e) { handles = []; }
    }
    return handles.map(function (h) { return byHandle[h]; })
      .filter(Boolean).slice(0, 3);
  }

  // Teilepreis in Zehntel-Cent, damit sich sauber runden laesst.
  function ppp10(p) {
    if (!p.teile || !p.price) return null;
    return Math.round((p.price * 10) / p.teile);
  }

  function fmtPpp(p) {
    var v = ppp10(p);
    if (v == null) return '—';
    return (v / 10).toLocaleString(CFG.locale || 'de-DE', {
      minimumFractionDigits: 1, maximumFractionDigits: 1
    }) + ' ct';
  }

  var ROWS = [
    { key: 'price',       label: 'Preis',        get: function (p) { return p.price ? money.format(p.price / 100) : '—'; }, best: 'min', raw: function (p) { return p.price; } },
    { key: 'ppp',         label: 'Preis je Teil',get: fmtPpp, best: 'min', raw: ppp10 },
    { key: 'teile',       label: 'Teile',        get: function (p) { return p.teile ? p.teile.toLocaleString('de-DE') : '—'; }, best: 'max', raw: function (p) { return p.teile; } },
    { key: 'minifiguren', label: 'Minifiguren',  get: function (p) { return p.minifiguren != null ? p.minifiguren : '—'; }, best: 'max', raw: function (p) { return p.minifiguren; } },
    { key: 'bauzeit',     label: 'Bauzeit',      get: function (p) { return p.bauzeit ? 'ca. ' + p.bauzeit + ' h' : '—'; } },
    { key: 'schwierigkeit', label: 'Niveau',     get: function (p) { return p.schwierigkeit || '—'; } },
    { key: 'alter_ab',    label: 'Alter',        get: function (p) { return p.alter_ab ? 'ab ' + p.alter_ab : '—'; } },
    { key: 'set_nummer',  label: 'Set-Nummer',   get: function (p) { return p.set_nummer || '—'; } },
    { key: 'eol_status',  label: 'Verfügbarkeit',get: function (p) { return p.eol_status || '—'; } },
    { key: 'zustand',     label: 'Zustand',      get: function (p) { return p.zustand || '—'; } },
    { key: 'masse',       label: 'Maße',         get: function (p) { return p.masse || '—'; } }
  ];

  function render() {
    var sets = selection();

    if (sets.length < 2) {
      root.innerHTML =
        '<p class="bk-compare__empty">Waehle mindestens zwei Sets aus. Klicke dazu auf einer ' +
        'Produktseite auf <strong>Zum Vergleich</strong> – die Auswahl erscheint dann unten am Bildschirmrand.</p>';
      return;
    }

    var head = '<th scope="col"></th>' + sets.map(function (p) {
      return '<th scope="col">' +
        '<a href="' + p.url + '">' +
        (p.image
          ? '<img src="' + p.image + '" alt="" loading="lazy" width="200" height="200">'
          : '<span class="bk-compare__noimg">Bild folgt</span>') +
        '<span class="bk-compare__title">' + p.title + '</span></a></th>';
    }).join('');

    var body = ROWS.map(function (row) {
      // Bestwert je Zeile markieren – aber nur, wenn es einen echten Unterschied gibt.
      var bestIdx = -1;
      if (row.best && row.raw) {
        var vals = sets.map(row.raw);
        var valid = vals.filter(function (v) { return typeof v === 'number' && !isNaN(v); });
        if (valid.length === sets.length && new Set(valid).size > 1) {
          var target = row.best === 'min' ? Math.min.apply(null, valid) : Math.max.apply(null, valid);
          bestIdx = vals.indexOf(target);
        }
      }
      var cells = sets.map(function (p, i) {
        return '<td' + (i === bestIdx ? ' class="bk-compare__best"' : '') + '>' + row.get(p) + '</td>';
      }).join('');
      return '<tr><th scope="row">' + row.label + '</th>' + cells + '</tr>';
    }).join('');

    var actions = '<tr><th scope="row"></th>' + sets.map(function (p) {
      return '<td><a class="bk-compare__cta" href="' + p.url + '">Zum Set</a></td>';
    }).join('') + '</tr>';

    root.innerHTML =
      '<div class="bk-compare__scroll"><table class="bk-compare__table">' +
      '<thead><tr>' + head + '</tr></thead>' +
      '<tbody>' + body + actions + '</tbody>' +
      '</table></div>';
  }

  render();
  window.addEventListener('popstate', render);
})();
